export const TestHooks = {
	UploadButton: 'upload-button',
	UploadedDocumentsSection: 'uploaded-documents-section',
	NoDocumentsSection: 'no-documents-section',
} as const;
